const state = {
    info: {
        memberId: 0,
        firstnameEn: null,
        lastnameEn: null,
        phoneNumber: null,
        email: null
    }
}

const getters = {
    info: state => state.info
}

const mutations = {
    UPDATE_INFO(state, payload) {
        state.info = payload;
    }
}

const actions = {
    casLogin({ commit }, param) {
        return new Promise((resolve, reject) => {
            console.log(param);
            $("#my_login_form").html("");
            $.ajax({
                url:
                    "https://www.egltours.com/cas5-b2c/login?service=https://www.egltours.com/local-travel/logging?page=" + param.page,
                data: null,
                processData: false,
                type: "POST",
                success: function (html) {
                    console.log(html);
                    $("#my_login_form").html(html);
                    setTimeout(function () {
                        document.getElementById("username").value = param.username;
                        document.getElementById("password").value = param.password;
                        document.getElementById("credentials").submit();
                        resolve();
                    }, 100);
                },
            });
            resolve();
        })
    },
    getMember({
        commit
    }) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', '/nmember-b2c-web/api/info');
            xhr.responseType = 'json';
            xhr.send();
            xhr.onload = function () {
                if (xhr.status === 200) {
                    const res = xhr.response;
                    console.log(res);
                    const payload = {
                        memberId: res.memberId,
                        firstnameEn: res.firstnameEn,
                        lastnameEn: res.lastnameEn,
                        phoneNumber: res.phoneNumber,
                        email: res.email
                    }
                    commit('UPDATE_INFO', payload);
                    resolve();
                }
            };

            xhr.onerror = function () {
                let xhr = new XMLHttpRequest();
                xhr.open('GET', '/nmember-b2c-web/api/info');
                xhr.responseType = 'json';
                xhr.send();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        const res = xhr.response;
                        console.log(res);
                        const payload = {
                            memberId: res.memberId,
                            firstnameEn: res.firstnameEn,
                            lastnameEn: res.lastnameEn,
                            phoneNumber: res.phoneNumber,
                            email: res.email
                        }
                        commit('UPDATE_INFO', payload);
                        resolve();
                    }
                };
            };

        })
    },
    casLogout({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url:
                    "https://www.egltours.com/cas5-b2c/logout?service=https://www.egltours.com/local-travel/",
                data: null,
                processData: false,
                type: "POST"
            });
            const payload = {
                memberId: 0,
                firstnameEn: null,
                lastnameEn: null,
                phoneNumber: null,
                email: null
            }
            commit('UPDATE_INFO', payload);
            resolve();
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}